<template>
  <section class="jsk-block d-flex">
      <div class="container mt-5 pt-5 jsk-block bg-cover" 
      :style="{'background-image':'url(' + require('./../assets/images/heroes/section-hero.png') + ')'}"
      >
        <div class="row text-center">
          <div class="col-12 col-lg-12 col-md-12 col-sm-12">
            <h1 class="mt-5">
              {{heroTitle}}
            </h1>
            <p>{{heroSubtitle}}</p>
          </div>
        </div>
      </div>
    </section>
</template>

<script>

export default {
  name: "hero",
  props: ["heroTitle", "heroSubtitle"]
  
};
</script>